// https://fontawesome.com/icons
// import '@fortawesome/fontawesome-free/js/all';
// a comment can go here

import 'leaflet/dist/leaflet'; //necessary
import 'leaflet-defaulticon-compatibility';
import './leaflet-timeline-slider';

import hosts from './dataHosts';
import greatPlayers from './dataGreatPlayers';
//import rankings from './dataRankings';
import * as manageLayers from './manageLayers';
import * as manageLayerSetUp from './manageLayerSetUp';
import * as manageLayerText from './manageLayerText';
import confederations from './dataConfederations';
import dataPolygonsFirst from './dataPolygonsFirst';
import fifaEntities from './dataFIFAEntities';
//import fans from './dataFans';

//import clubs from './dataClubs';
import groups from './dataGroups';
import tournys from './dataTournys';
import * as manageData from './manageData';
import * as htmlBuilder from './htmlBuilder';
import * as firebaseHelpers from './firebase/helpers';
import '../scss/styles.scss';
import settings from './dataSettings';
window.settings = settings;

function setUpMap() {
    settings.globals.map = new L.Map('map', {
        zoomDelta: settings.map.zoomDelta,
        zoomSnap: settings.map.zoomSnap,
        zoomControl: false,
        attributionControl: false,
    }).setView([0, 0], 1); //this view is just a placeholder

    settings.globals.map.on('popupopen', (e) => {
        if (e.popup.myOnOpenPopUpFunc) {
            // if there is a function that needs running
            e.popup.myOnOpenPopUpFunc(e.popup.entityID); //then run it
        }
    });

    settings.globals.map.setMaxZoom(settings.map.maxZoom);
}
/**
 * @param whichTourny
 */
function initializeNonChangingGlobals() {
    settings.polygons = dataPolygonsFirst; //these don't change based on tourny
    //settings.globals.clubs = clubs; //these don't change based on tourny
    settings.groups = groups; //these don't change based on tourny
    settings.fifaEntities = fifaEntities; //these don't change based on tourny
    //settings.fans = fans; //these don't change based on tourny
    settings.confederations = confederations; //the tally's do change and get re-intialized (see tally)
    settings.tournys = tournys.tournaments; //these don't change based on tourny
    settings.hosts = hosts; //these don't change based on tourny
    settings.greatPlayers = greatPlayers; //these don't change based on tourny
    manageLayerSetUp.setUpLayerParameters();
}

async function initializeTourny(whichTourny) {
    let theTourny = settings.tournys.find((k) => k.tournyID === whichTourny);
    if (theTourny) {
        await manageData.pullCorrectData(whichTourny); //this comes first because everything else depends on it

        htmlBuilder.dumpLayers();
        htmlBuilder.initializeMenuAndSideBar(); //some menu items are tourny dependent

        settings.globals.currentTeamID = settings.globals.currentTourny.startEntityID;
        settings.globals.currentFromEntityID = settings.globals.currentTourny.startEntityID;
        manageData.tallyResults();
        manageLayerText.getGroupStandingsText();

        manageData.tallyPlayersComingToFromConfederations(); //this should be not always be called because for certain tournaments this is irrelevant

        htmlBuilder.addHeaderActiveClass();
        htmlBuilder.addSideBarActiveClass();

        //some layers on tourny dependent, create all each time the tourny changes for simplicity
        manageLayers.createLayers();

        // event listeners:  these listeners get re-installed because the menu gets rebuilt for each tourny
        document.querySelector('.hamburger').addEventListener('click', function (e) {
            let state = document.querySelector('html').getAttribute('data-mobile_nav_open') === 'true';
            document.querySelector('html').setAttribute('data-mobile_nav_open', !state);
        });

        document.querySelector('.tourny_selectorMenu').addEventListener('click', function (e) {
            const tournyID = e.target.getAttribute('data-tournyID');
            initializeTourny(tournyID);
            //}, 300);
        });
        setTimeout(function () {
            /*  if (theTourny.requiresLogIn && !settings.globals.firebase.activeSubscription) {
                document.querySelector('[data-logIn_layer]').click();
            } else */
            document.querySelector('[data-start_layer]').click();
        }, 300);
    }
}

const map = document.getElementById('map');

if (map) {
    // COMMENTED OUT: Previous initialization flow - no auth check before showing content
    // Previously: Initialized Firebase, map, and content immediately without checking authentication
    // firebaseHelpers.initFirebase();
    // setUpMap();
    // initializeNonChangingGlobals();
    // initializeTourny(settings.misc.startTourny);

    // NEW: Wait for Firebase auth state before initializing content (mandatory login)
    // Hide main content initially - will be shown only after authentication
    // Note: LeftBarContainer will be shown for login screen, then hidden when content loads
    const main = document.querySelector('#main');
    const header = document.querySelector('#Header');
    const leftBarContainer = document.querySelector('#LeftBarContainer');

    // Set initial state - not authenticated (will be updated after Firebase check)
    document.querySelector('html').setAttribute('data-authenticated', 'false');

    // Hide map and header (main content)
    if (map) map.style.display = 'none';
    if (header) header.style.display = 'none';
    // Keep main visible initially (it contains LeftBarContainer which will show login)
    // LeftBarContainer visibility will be managed when login screen is shown

    // Listen for user authentication event (for when user logs in after initial page load)
    window.addEventListener('userAuthenticated', function (event) {
        if (event.detail && event.detail.needsInitialization && !settings.globals.map) {
            console.log('User authenticated event received, initializing map and content');
            setUpMap();
            initializeNonChangingGlobals();
            initializeTourny(settings.misc.startTourny);

            // After initialization, switch to callback layer if one was requested
            if (settings.globals.firebase.callBackLayerIndex !== null) {
                const callBackLayer = settings.globals.firebase.callBackLayerIndex;
                settings.globals.firebase.callBackLayerIndex = null; // Clear callback
                // Small delay to ensure map is fully initialized
                setTimeout(() => {
                    htmlBuilder.switchModes(callBackLayer);
                }, 100);
            }
        }
    });

    // Initialize Firebase and wait for auth state
    firebaseHelpers
        .initFirebase()
        .then((firebaseUser) => {
            if (firebaseUser) {
                // User is authenticated - show content and initialize
                console.log('User authenticated, initializing content');

                // Set HTML attribute to indicate authenticated
                document.querySelector('html').setAttribute('data-authenticated', 'true');

                // Show all content (map, header, leftBarContainer will be visible)
                if (map) map.style.display = '';
                if (header) header.style.display = '';
                // leftBarContainer will be shown/hidden by layer system as needed

                // Hide login container if it's visible
                const loginContainer = document.querySelector('#myFirebaseUI-Container');
                if (loginContainer) loginContainer.style.display = 'none';

                // Initialize the app
                setUpMap();
                initializeNonChangingGlobals();
                initializeTourny(settings.misc.startTourny);

                // After initialization, switch to callback layer if one was requested
                if (settings.globals.firebase.callBackLayerIndex !== null) {
                    const callBackLayer = settings.globals.firebase.callBackLayerIndex;
                    settings.globals.firebase.callBackLayerIndex = null; // Clear callback
                    // Small delay to ensure map is fully initialized
                    setTimeout(() => {
                        htmlBuilder.switchModes(callBackLayer);
                    }, 100);
                }
            } else {
                // User is NOT authenticated - show login screen and keep content hidden
                console.log('User not authenticated, showing login screen');

                // Set HTML attribute to indicate not authenticated (for CSS targeting)
                document.querySelector('html').setAttribute('data-authenticated', 'false');

                // Initialize layer parameters first (needed for buildSubscribe to work)
                initializeNonChangingGlobals();

                // Ensure LeftBarContainer is visible (it contains the login form)
                if (leftBarContainer) {
                    leftBarContainer.style.display = 'block';
                    leftBarContainer.style.opacity = '1';
                    leftBarContainer.style.width = '100%';
                    leftBarContainer.style.position = 'relative';
                    leftBarContainer.style.zIndex = '1000';
                }

                // Build the subscribe/login layer HTML (contains login form)
                // This creates the #myFirebaseUI-Container and login form HTML
                htmlBuilder.buildSubscribe();

                // Small delay to ensure DOM is updated
                setTimeout(() => {
                    // Show login container
                    const loginContainer = document.querySelector('#myFirebaseUI-Container');
                    const leftBarEl = document.getElementById('LeftBar');
                    const customLoginForm = document.querySelector('#custom-login-form');

                    console.log('Login setup check:');
                    console.log('- Login container:', loginContainer);
                    console.log('- LeftBar element:', leftBarEl);
                    console.log('- LeftBar innerHTML length:', leftBarEl?.innerHTML?.length);
                    console.log('- Custom login form:', customLoginForm);
                    console.log('- LeftBarContainer:', leftBarContainer);
                    console.log('- LeftBarContainer width:', leftBarContainer?.style?.width);
                    console.log('- LeftBarContainer display:', leftBarContainer?.style?.display);

                    if (loginContainer) {
                        loginContainer.style.display = 'block';
                        console.log('✓ Login container found and displayed');
                        // Trigger login UI setup - this will set up the login form event handlers
                        firebaseHelpers.handleLogInAndSubscribe();
                    } else {
                        // Fallback: If login container still doesn't exist, log warning
                        console.error('✗ Login container not found - content may not be accessible');
                        console.error('LeftBar innerHTML:', leftBarEl?.innerHTML?.substring(0, 200));
                    }
                }, 100);
            }
        })
        .catch((error) => {
            console.error('Error initializing Firebase:', error);
            // On error, show login screen as fallback
            const loginContainer = document.querySelector('#myFirebaseUI-Container');
            if (loginContainer) {
                loginContainer.style.display = 'block';
                firebaseHelpers.handleLogInAndSubscribe();
            }
        });
}
